module.exports = __webpack_public_path__ + "img/MundZuVollGenommen.8eca39d5.svg";